import React from 'react'
import PropTypes from 'prop-types'

import useRect from '../hooks/useRect'
import { PROPTYPES_RECT } from '../components/constants'

import MultiLineChart from '_components/audience-insights/charts/multi-line/index.jsx'

function MultiLineChartHOC({ data, yLabel, headerChartRect, replaceLegend }) {
  const [Rect, rect] = useRect()

  const dataFormatted = replaceLegend
    ? data.map((entry) => ({
        ...entry,
        values: Object.fromEntries(
          Object.entries(entry.values).map(([key, value]) => [replaceLegend[key], value])
        ),
      }))
    : data

  return (
    <>
      <Rect />
      <foreignObject
        x="0"
        y="0"
        width={rect.width}
        height={rect.height}
        data-custom-render="ai-chart-multi-line"
        data-json={JSON.stringify(dataFormatted)}
        data-y-label={yLabel}
      >
        <MultiLineChart
          data={dataFormatted}
          hasLegend={true}
          yLabel={yLabel}
          config={{
            lineChart: {
              width: rect.width,
              height: rect.height,
              margin: {
                top: headerChartRect.height,
              },
            },
          }}
        />
      </foreignObject>
    </>
  )
}

MultiLineChartHOC.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      month: PropTypes.string.isRequired,
      values: PropTypes.shape({}),
    })
  ),
  yLabel: PropTypes.string,
  headerChartRect: PropTypes.shape(PROPTYPES_RECT),
  replaceLegend: PropTypes.objectOf(PropTypes.string),
}

export default MultiLineChartHOC
